module.exports = __webpack_public_path__ + "static/media/DRTGTryOn.4491b5e9.svg";